import React from 'react';
import './subscription.css';

const Subscription = ({ onClose }) => {
    return (
        <div className="popup-overlay">
            <div className="popup-container">
                <button className="close-button" onClick={onClose}>{'\u00D7'}</button>
                <div className="popup-content">
                    <p>Subscription.</p>
                </div>
            </div>
        </div>
    );
};

export default Subscription;